<div class="modal-header">
  <h4 class="modal-title" id="modal-title" translate>ADD_RIMS</h4>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <colmec-rim-list-by-ids [productIds]="rimIds" [parentProductId]="parentProductId"></colmec-rim-list-by-ids>
  <div class="row">
    <div class="col-12">
      <div
        *ngIf="alertMessage"
        class="alert mt-2 text-center"
        role="alert"
        [ngClass]="{ 'alert-success': alertMessage.type === 'success', 'alert-danger': alertMessage.type === 'danger' }"
        (click)="alertMessage = null"
      >
        <span>{{ alertMessage.message | translate }}</span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="assemblyProductPriceArray.length > 0" class="modal-footer">
  <div class="row w-100">
    <div class="col">
      <div class="form-group">
        <label for="selectedAssembly" class="control-label" translate>SELECT_ASSEMBLY</label>:
        <select
          name="selectedAssembly"
          id="selectedAssembly"
          class="form-control form-select ml-1"
          [(ngModel)]="selectedAssembly"
        >
          <option *ngFor="let assembly of assemblyProductPriceArray" [value]="assembly.key">
            {{ assembly.value.product.name }} -
            <lib-price *ngIf="!hidePrice" [price]="assembly.value.customerProductPrice" type="NET"></lib-price>
          </option>
        </select>
      </div>
    </div>
    <div class="col d-flex justify-content-end">
      <button type="button" class="btn btn-light btn-sm" (click)="onClear()" translate>CLEAR_AND_CLOSE</button>
      <button type="button" class="btn btn-primary btn-sm ml-2" (click)="onAdd()" translate>ADD_AND_CLOSE</button>
    </div>
  </div>
</div>
